import { Injectable } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { RicercaRivenditoriComponent } from 'src/app/components/inside/configuration/conf-dashboard/ricerca-rivenditori/ricerca-rivenditori.component';
import { EmailModalComponent } from 'src/app/components/inside/invoices/active-invoices/email-modal/email-modal.component';
import { CompanyModalComponent } from 'src/app/components/inside/users/user-editor/company-modal/company-modal.component';
import { RicercaAziendaComponent } from 'src/app/components/inside/users/user-editor/ricerca-azienda/ricerca-azienda.component';
import { ChangePwModalComponent } from 'src/app/components/profile/change-pw-modal/change-pw-modal.component';
import { ChangeLogModalComponent } from 'src/app/components/utils/change-log-modal/change-log-modal.component';
import { ConfirmModalComponent } from 'src/app/components/utils/confirm-modal/confirm-modal.component';
import { EsitaModalComponent } from 'src/app/components/utils/esita-modal/esita-modal.component';
import { PreviewModalComponent } from 'src/app/components/utils/preview-modal/preview-modal.component';
import { UTILS } from 'src/app/entities/Utils';
import { Azienda } from 'src/app/entities/various';
@Injectable({
  providedIn: 'root'
})
export class ModalServiceService {

  constructor(private modalService: NgbModal, private translate: TranslateService) { }

  openChangeLog(): NgbModalRef {
    return this.modalService.open(ChangeLogModalComponent, { size: 'lg' });
  }


  async openConfirm(title: string, description: string){
    let modalRef : NgbModalRef = this.modalService.open(ConfirmModalComponent);
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.description = description;
    let response : boolean | undefined = await modalRef.result.then(result => {return result;}).catch(err => {return null});
    return response ? response : false;
  }

  async openConfirmBozza(title: string, description: string){
    let modalRef : NgbModalRef = this.modalService.open(ConfirmModalComponent);
    modalRef.componentInstance.title = title;
    modalRef.componentInstance.description = description;
    modalRef.componentInstance.si = await new UTILS().getTranslateTitle(this.translate, "modal.labels.si");
    modalRef.componentInstance.no = await new UTILS().getTranslateTitle(this.translate, "modal.labels.no");
    let response : boolean | undefined = await modalRef.result.then(result => {return result;}).catch(err => {return null});
    return response ? response : false;
  }

  async openPreview(fileUrl : string, fileName : string) {
    let modalRef : NgbModalRef = this.modalService.open(PreviewModalComponent, {size: 'xl'});
    modalRef.componentInstance.fileUrl = fileUrl;
    modalRef.componentInstance.fileName = fileName;
    let response : boolean | undefined = await modalRef.result.then(result => {return result;}).catch(err => {return null});
    return response ? response : false;
  }

  async openEsitaFattura(userId: string, fatturaId : string) {
    let modalRef : NgbModalRef = this.modalService.open(EsitaModalComponent, {size: 'xl'});
    modalRef.componentInstance.userId = userId;
    modalRef.componentInstance.invoiceId = fatturaId;
    let response : boolean | undefined = await modalRef.result.then(result => {return result;}).catch(err => {return null});
    return response ? response : false;
  }

  async openSendEmail (docId: string, userId: any) {
    let modalRef : NgbModalRef = this.modalService.open(EmailModalComponent,  {size: 'lg'} );
    modalRef.componentInstance.invoiceId = docId;
    modalRef.componentInstance.userId = userId;
    let response : boolean | undefined = await modalRef.result.then(result => {return result;}).catch(err => {return null});
    return response ? response : false;
  }

  async openChangePassword (userId: any) {
    let modalRef : NgbModalRef = this.modalService.open(ChangePwModalComponent);
   
    modalRef.componentInstance.userId = userId;
    let response : boolean | undefined = await modalRef.result.then(result => {return result;}).catch(err => {return null});
    return response ? response : false;
  }

  async openCreateAzienda(userId: any) {
    let modalRef : NgbModalRef = this.modalService.open(CompanyModalComponent,  {size: 'lg'} );
    modalRef.componentInstance.userId = userId;
    let response : boolean | undefined = await modalRef.result.then(result => {return result;}).catch(err => {return null});
    return response ? response : false;
  }
  
  async openCreateAziendaAndGet(userId: any) {
    let modalRef : NgbModalRef = this.modalService.open(CompanyModalComponent,  {size: 'lg'} );
    modalRef.componentInstance.userId = userId;
    modalRef.componentInstance.returnData= true;
    let response : boolean | undefined | any = await modalRef.result.then(result => {return result;}).catch(err => {return null});
    return response ? response : false;
  }

  async searchAzienda(userId:any){
    let modalRef : NgbModalRef = this.modalService.open(RicercaAziendaComponent,  {size: 'md'} );
    modalRef.componentInstance.userId = userId;
    let response : boolean | undefined | any = await modalRef.result.then(result => {return result;}).catch(err => {return null});
    return response ? response : false;
  }


  async searchRivenditori(userId:any){
    let modalRef : NgbModalRef = this.modalService.open(RicercaRivenditoriComponent,  {size: 'lg'} );
    modalRef.componentInstance.userId = userId;
    let response : boolean | undefined | any = await modalRef.result.then(result => {return result;}).catch(err => {return null});
    return response ? response : false;
  }

}
